import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Field, reduxForm} from 'redux-form';

import {
    Alert,
    Col,
    Row
} from 'reactstrap';

import {handleAddInvite} from '../actions/roommates';
import {InputField} from '../../../validation/ReduxFormInput';
import {FormAsyncButton} from "../../../components/controls/buttons/AsyncButton";

class AddInviteForm extends Component {
    constructor(props) {
        super(props);
        this.submit = this.submit.bind(this);
    }

    state = {
        acting: false
    };

    submit(values) {
        this.setState({acting: true});
        this.props._handleAddInvite(values).then(() => {
            this.setState({acting: false});
            this.props.onComplete();
        });
    }

    render() {

        const {handleSubmit, _handleAddInvite, pristine, error} = this.props;

        return (
            <div>
                <form onSubmit={handleSubmit(this.submit)}>
                    <Row>
                        <Col xs={12} sm={6}><Field name="first_name" label="First Name" placeholder="First" component={InputField}/></Col>
                        <Col xs={12} sm={6}><Field name="last_name" label="Last Name" placeholder="Last" component={InputField}/></Col>
                        <Col xs={12}><Field name="email" label="Email" placeholder="Email" component={InputField} type="email"/></Col>
                    </Row>
                    {/*<Button type="submit" color="success" disabled={pristine || submitting} outline block>Invite <i className="fa fa-plus"></i></Button>*/}
                    <FormAsyncButton acting={this.state.acting} type="submit" color="success" disabled={pristine} outline block>Invite <i className="fa fa-plus"></i></FormAsyncButton>
                    {
                        error &&
                        <div className="center" style={{marginTop: '5px'}}>
                            <Alert color="danger">
                                {error}
                            </Alert>
                        </div>
                    }
                </form>
            </div>
        );
    }
}

const validate = values => {
    const errors = {};

    !values.first_name && (errors.first_name = 'Required');
    !values.last_name && (errors.last_name = 'Required');
    !values.email && (errors.email = 'Required');

    return errors;
};

AddInviteForm = reduxForm({
    form: 'addInviteForm',
    validate
})(AddInviteForm);

const mapStateToProps = (state) => ({});

const mapDispatchToProps = (dispatch, props) => {
    return {
        _handleAddInvite(data) {
            return dispatch(handleAddInvite(data));
        }
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(AddInviteForm);


// WEBPACK FOOTER //
// ./src/containers/tenant/dashboard/AddInviteForm.js